import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { BRAND, PRODUCT_NAME, heroBadges } from '../../data/salesContent';
export function HeroSection() {
  return <header className="bg-carbon-950 px-5 pb-12 pt-8 text-center md:px-12 md:pb-14 md:pt-10" data-id="element-105" data-mp="219l2zb9wmci5">
      <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-accent-400 md:text-base" data-id="element-106" data-mp="1x9ao1944wbr5">{BRAND}</p>
      <h1 className="mx-auto mt-4 max-w-2xl text-[2.25rem] font-extrabold uppercase leading-[1.02] text-white md:text-[3.25rem]" data-id="element-107" data-mp="1saps3lvx0e8i">
        El sistema completo para enseñar <span className="text-accent-400" data-id="element-108" data-mp="1ijlfgstpp5gu">Construcciones</span> de principio a fin
      </h1>
      <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-109" data-mp="1dks4p85t7skd">
        Dejá de preparar cada tema desde cero: planos, materiales, estructuras, instalaciones, obra, seguridad, cómputo y
        planificación organizados en un solo sistema.
      </p>
      <ProductImage className="mx-auto mt-6 w-full max-w-xl" data-id="element-110" data-mp="14mg3kc7bhcdo" />

      <p className="mt-6 font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-3xl" data-id="element-111" data-mp="31mkx9lmk08x4">{PRODUCT_NAME}</p>
      <p className="mt-1 font-display text-lg font-bold uppercase tracking-wide text-accent-400 md:text-xl" data-id="element-112" data-mp="36gxfjscane7a">
        10 volúmenes + 5 bonos prácticos
      </p>
      <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-113" data-mp="2wpuid1mhjjda">
        {heroBadges.map(({
        label,
        icon: Icon
      }) => <li key={label} className="flex items-center gap-2 text-sm font-semibold text-carbon-100" data-id="element-114" data-mp="3pdqfg7fyvdal">
            <Icon className="h-4 w-4 shrink-0 text-accent-400" aria-hidden="true" data-id="element-115" data-mp="3be7go591peay" />
            {label}
          </li>)}
      </ul>
      <div className="mt-7" data-id="element-116" data-mp="3gbz7sx1v8we3">
        <CtaButton data-id="element-117" data-mp="3gb7bfk0g2umr">Quiero acceder al sistema completo</CtaButton>
      </div>
    </header>;
}